import axios from "axios";
import { persistor, persistConfig } from "../../store"
import asyncHandler from "express-async-handler";
const apiUrl = process.env.REACT_APP_API_URL || '';



//NEW NEW NEW
const fetchCustomers = async (sendData) =>{
    const response = await axios.get(`${apiUrl}/api/users/fetchCustomers`, sendData)
    return response.data
}



//create pass
const sendEmail = async (sendData) =>{
    const response = await axios.post(`${apiUrl}/api/email/sendemail`, sendData)
    return response.data
}





//new check subcription status - no token
const getSubscriptionStatus = async (id) => {

    // console.log("getsubscriptionstatus service firing with id:", id);
    const response = await axios.get(`${apiUrl}/api/subscription/getsubscriptionstatus?id=${id}`);


    return response.data;
};




//generic manage subscription status
const manageSubscriptionStatus = async (id, newStatus) =>{
    const response = await axios.post(`${apiUrl}/api/subscription/managesubscriptionstatus`, {id, newStatus})
    return response.data
}



//activate subscription from pending
const activateSubscription = async (id) =>{
    return await axios.patch(`${apiUrl}/api/subscription/activatesubscription`, {id})
}



//create user on back end
const createUser = async (userData) =>{
    const response = await axios.post(`${apiUrl}/api/users/createUser`, userData)
    return response.data
}



//grab user id on the back end
const grabUserID = async (grabData) =>{


    const response = await axios.get(`${apiUrl}/api/users/grabuserid?email=${grabData.email}`)

    return response.data
}



const getCurrentUser = async (id) => {
    // console.log("getCurrentUser service firing with id:", id)
    const response = await axios.post(`${apiUrl}/api/users/getcurrentuser`, {id})
    return response.data
}





const userSignUp = async (userData) =>{
    const response = await axios.post(`${apiUrl}/api/users/usersignup`, userData)
    return response.data
}



const logIn = async (userData, token) => {

    // Include the token in userData
    userData.token = token;

    const response = await axios.post(`${apiUrl}/api/users/login`, userData);


    if (response.data) {
        localStorage.setItem("user", JSON.stringify(response.data));
        sessionStorage.setItem("sessionUser", JSON.stringify(response.data));

    }

    return response.data;
};



const grabToken = async (userData) => {
    try {
        // console.log("grabtoken service grabbing with user (test): ", userData)

        const response = await axios.post(`${apiUrl}/api/users/grabtoken`, userData);
        // console.log("grabtoken service response: " + JSON.stringify(response,null,2))



        if (response.data) {
            localStorage.setItem("token", response.data.jwt_token)
        }

        return response; // Returning the entire response
    } catch (error) {
        console.error("Error in grabtoken service:", error);
        throw error;
    }
};


const checkCouponValidity = async (kipMateCode) =>{
    const response = await axios.post(`${apiUrl}/api/subscription/checkcouponvalidity/`, {kipMateCode})
    return response.data
}

const checkCouponProducts = async (kipMateCode) =>{
    const response = await axios.post(`${apiUrl}/api/subscription/checkcouponproducts/`, {kipMateCode})
    return response.data
}

//COME BACK
const patchCurrentUser = async (id, newUserData, token) => {

    const response = await axios.patch(`${apiUrl}/api/users/patchuser/`, { ...newUserData, id, token })

    if (response) {
        const user = JSON.parse(localStorage.getItem("user")) || {}
        user.first_name = response.data.first_name
        user.last_name = response.data.last_name
        user.email = response.data.email
        localStorage.setItem("user", JSON.stringify(user))

    } else {
        console.log("something went wrong somewhere")
    }

    return response.data
}


//log user out
const logOut = () =>{
    localStorage.removeItem("user")
    localStorage.removeItem("token")
    localStorage.removeItem("persist:root")
    persistor.purge();
    localStorage.removeItem(persistConfig.key);
    persistConfig.purge();
}

const authService = {
    logOut,
    logIn,
    grabToken,
    sendEmail,
    patchCurrentUser,
    createUser,
    userSignUp,
    grabUserID,
    getSubscriptionStatus,
    getCurrentUser,
    manageSubscriptionStatus,
    activateSubscription,
    checkCouponValidity,
    checkCouponProducts,
    fetchCustomers

}

export default authService;
